import { sva } from '@allenai/varnish-panda-runtime/css';
import type { RecipeVariantProps } from '@allenai/varnish-panda-runtime/types';

const modalStyles = sva({
    slots: ['overlay', 'modal', 'dialog', 'heading', 'content', 'actions', 'closeButton'],
    base: {
        overlay: {
            inset: '[0]',
            position: 'fixed',
            display: 'flex',
            zIndex: 'modal',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '[black/80]', // need overlay tokens: https://github.com/allenai/varnish/issues/1148
        },
        modal: {
            boxSizing: 'border-box',
            display: 'flex',
            '--modal-margin': '32px',
            margin: 'var(--modal-margin)',
            maxHeight: '[calc(100% - var(--modal-margin))]',

            borderRadius: 'sm',
            outline: 'none', // we don't want a focus ring on the div
        },
        dialog: {},
        heading: {
            padding: '[8px 16px]',

            display: 'flex',
            columnGap: '[8px]',
            justifyContent: 'space-between',
            alignItems: 'start',
        },
        content: {
            overflowY: 'auto',
            // TODO, check with design:
            // scrollbarGutter: 'stable both-edges',
            paddingInline: '[16px]',
        },
        actions: {
            padding: '[8px 16px]',
        },
        closeButton: {
            alignSelf: 'start',
            padding: '0',
        },
    },
    variants: {
        fullWidth: {
            true: {
                modal: {
                    flex: '1',
                    width: '[100%]',
                },
            },
        },
        size: {
            small: {
                modal: {
                    maxWidth: '[300px]',
                },
            },
            medium: {
                modal: {
                    maxWidth: '[500px]',
                },
            },
            large: {
                modal: {
                    maxWidth: '[800px]',
                },
            },
            // TODO: Design input:
            // full: {
            //     modal: {
            //         width: '[100%]',
            //         height: '[100%]',
            //         margin: '[0]',
            //     },
            // },
        },
        color: {
            default: {
                modal: {
                    backgroundColor: 'background.opacity-100',
                    color: 'text',
                },
            },
            reversed: {
                modal: {
                    backgroundColor: 'background.opacity-100.reversed',
                    color: 'text.reversed',
                },
            },
        },
    },
    defaultVariants: {
        size: 'medium',
        color: 'default',
    },
});

type ModalRecipeProps = Exclude<RecipeVariantProps<typeof modalStyles>, undefined>;

export { modalStyles };
export type { ModalRecipeProps };
